var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-block"},[_c('v-img',_vm._b({attrs:{"src":require("@/assets/icons/cheeers.small.png")}},'v-img',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }